import Wizard from '@service-victoria/component-library/components/Wizard/props';
import { FormikErrors, FormikTouched } from 'formik';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { TransactionSteps } from 'interfaces/transaction';

import * as Done from './Done';
import * as EarlyDevelopment from './EarlyDevelopment';
import * as LargeSite from './LargeSite';
import * as Review from './Review';
import * as SiteOperatorDetails from './SiteOperatorDetails';
import * as SmallSite from './SmallSite';
import * as StateCritical from './StateCritical';
import * as YourWorkSite from './YourWorkSite';

export const steps: Wizard.Step<any>[] = [
  SiteOperatorDetails.Step,
  YourWorkSite.Step,
  SmallSite.Step,
  LargeSite.Step,
  StateCritical.Step,
  EarlyDevelopment.Step,
  Review.Step,
  Done.Step
];

export const initialErrors: FormikErrors<TransactionSteps> = {
  business: SiteOperatorDetails.initialErrors,
  worksite: YourWorkSite.initialErrors,
  review: Review.initialErrors
};

export const initialTouched: FormikTouched<TransactionSteps> = {
  business: SiteOperatorDetails.initialTouched,
  worksite: YourWorkSite.initialTouched,
  review: Review.initialTouched
};

export const validationSchema = Yup.object().shape<TransactionSteps>({
  business: SiteOperatorDetails.SiteOperatorDetailsSchema,
  worksite: YourWorkSite.YourWorkSiteSchema,
  smallSite: SmallSite.SmallSiteSchema,
  largeSite: LargeSite.LargeSiteSchema,
  earlyDevelopment: EarlyDevelopment.EarlyDevelopmentSchema,
  stateCritical: StateCritical.StateCriticalSchema,
  review: Review.ReviewSchema,
  transactionId: Yup.string().required()
});

export const initialValues: TransactionSteps = {
  business: SiteOperatorDetails.initialValues,
  worksite: YourWorkSite.initialValues,
  review: Review.initialValues,
  smallSite: SmallSite.initialValues,
  largeSite: LargeSite.initialValues,
  earlyDevelopment: EarlyDevelopment.initialValues,
  stateCritical: StateCritical.initialValues,
  transactionId: v4()
};

export const initialStepId = SiteOperatorDetails.Step.id;
